angular
    .module('WizApp', [
        'ngAnimate',
        'ngMessages',
        'ngSanitize',
        'wizcore'
    ])

    // mock unused service
    .constant('tagsInputConfigProvider', { mocked: true })
;
